<div class="screen-element control-showcase">
  <div class="title">{{title|uppercase}}</div>
  <!--<div class="dashboard-center">
  <div class="icon {{dashIcon}}"></div>
</div>-->
<div class="text">
  @for (t of text; track t) {
    <div>
      <text-widget [text]="translator.tr(t)" [color]="'white'"></text-widget>
    </div>
  }
</div>
</div>